import React from "react";

// Reusable inner-page hero banner with title over a dark image overlay
const PageHero = ({ title, subtitle, image }) => {
  return (
    <section className="relative h-[280px] md:h-[340px] overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${image})` }} />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f2740]/90 via-[#15324f]/80 to-[#0f2740]/70" />
      <div className="relative h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="w-14 h-[3px] bg-[#2f80c4] mb-5" />
        <h1
          className="text-white text-3xl md:text-5xl font-bold tracking-wide uppercase"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          {title}
        </h1>
        {subtitle && <p className="mt-3 text-white/80 text-base md:text-lg max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;
